// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  width: 1.25rem;\n  height: 1.25rem;\n}\nspan[data-v-4e6f274c] {\n  font-family: \"PingFang SC\";\n  font-weight: 400;\n  font-size: 0.875rem;\n  color: #a5a5ad;\n}\n.hamburger.is-active[data-v-4e6f274c] {\n  transform: rotate(180deg);\n}\nimg[data-v-4e6f274c] {\n  width: 1.125rem;\n  object-fit: contain;\n}", ""]);
// Exports
module.exports = exports;
